import React from 'react';
interface FormProgressProps {
  currentStep: number;
  totalSteps: number;
}
const FormProgress: React.FC<FormProgressProps> = ({
  currentStep,
  totalSteps
}) => {
  const progress = (currentStep + 1) / totalSteps * 100;
  return <div className="mb-8" data-id="element-46" data-mp="2a0pgx72stwoy">
      <div className="flex justify-between items-center mb-2" data-id="element-47" data-mp="2a1haydgqzmd4">
        <span className="text-sm font-medium text-navy-700" data-id="element-48" data-mp="2e1hsi6z58doe">
          Step {currentStep + 1} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-navy-700" data-id="element-49" data-mp="31sdnte2t5r0e">
          {Math.round(progress)}% Complete
        </span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-50" data-mp="2sy8pk9lchdau">
        <div className="bg-navy-600 h-2.5 rounded-full transition-all duration-300" style={{
        width: `${progress}%`
      }} data-id="element-51" data-mp="2svwca9qj7r44"></div>
      </div>
    </div>;
};
export default FormProgress;